import { render, staticRenderFns } from "./ConfirmNewQuote.vue?vue&type=template&id=29970cdd&scoped=true&"
import script from "./ConfirmNewQuote.vue?vue&type=script&lang=ts&"
export * from "./ConfirmNewQuote.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmNewQuote.vue?vue&type=style&index=0&id=29970cdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29970cdd",
  null
  
)

export default component.exports